import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const DeliveryContainer = styled.article`
    width: 50%;
    height: 150px;
    background: ${Colors.gradient};
    border-radius: 20px;

    position: relative;
    margin: 10% auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    
    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 80%;
        height: 100px;
        margin: 0 auto;
        margin-bottom: 15%;
    }
`;

export const DeliveryText = styled.h2`
    width: 35%;
    margin-left: 10%;
    font: 1.5rem/1.2 'Titan One',arial,sans-serif;
    color: ${Colors.white};

    span{
        display: block;
        margin-top: 10px;
        font: .85rem/1.2 'Varela Round',arial,sans-serif;
    }

    .texto-juridico{
        font: .65rem/1.2 'Varela Round',arial,sans-serif;
        color: ${Colors.white};

        /* position: absolute;
        bottom: -15px; */
        right: 5px;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 45%;
        margin-left: 7.5%;
        font-size: 1rem;
    }
`;

export const DeliveryImage = styled.img`
    width: 45%;
    position: absolute;
    right: 10%;

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 50%;
        right: 0;
    }
`;